import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import Card from "@/components/Card.vue";
import Thumbnail from "@/components/Thumbnail.vue";
let MiniCart = class MiniCart extends Vue {
    constructor() {
        super(...arguments);
        this.order = this.$store.state.order;
        this.colors = this.$store.getters.colors;
        this.totalItems = 0;
        this.totalPrice = 0;
        this.currency = '';
    }
    openOrder() {
        this.$router.push('/order');
    }
    mounted() {
        this.orderDetails();
    }
    orderDetails() {
        for (let i = 0; i < this.order.items.length; i++) {
            this.totalItems = this.totalItems + this.order.items[i].quantity;
            this.totalPrice = this.order.subtotal;
            this.currency = this.$store.state.currency;
        }
    }
};
MiniCart = __decorate([
    Component({ components: {
            Card,
            Thumbnail
        } })
], MiniCart);
export default MiniCart;
